/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const ModalHeader = ({ ...props }) => <div className="modal-header border-0">{props.children}</div>;

ModalHeader.propTypes = {
  children: PropTypes.object,
};

export default ModalHeader;
